import React, {type PropsWithChildren} from 'react';
import {TaxesEnvContext, type TaxesEnv} from './env';

export function TaxesEnvProvider({
  value,
  children,
}: PropsWithChildren<{value: TaxesEnv}>) {
  return <TaxesEnvContext.Provider value={value}>{children}</TaxesEnvContext.Provider>;
}
